import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import HataSiniri from './components/HataSiniri';
import { genelHataDinleyicisiKur } from './utils/hataBildir';

// V71.17 — ekranı çökertmeyen hatalar da Hata Kayıtları'na düşer
genelHataDinleyicisiKur();

// Mac'te arayüz fazla büyük görünüyor → %90 ölçek (iPad hariç)
if (/Mac/.test(navigator.platform) && !(navigator.maxTouchPoints > 1)) {
  document.documentElement.style.zoom = '0.9';
  document.documentElement.style.setProperty('--vh100', 'calc(100vh / 0.9)'); // zoom vh'yi de küçültür → tam yükseklik telafisi
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HataSiniri>
      <App />
    </HataSiniri>
  </React.StrictMode>
);
